import React from "react";
import ChicSleekBanner from "./../../../../../Images/Blog/Chic & Sleek/Banner Image.png";

const ChicSleekBannerImg = () => {
  return (
    <div className="blogImg-content">
      <img src={ChicSleekBanner} alt="spaDayBanner" loading="lazy"/>
    </div>
  );
};

export default ChicSleekBannerImg;
